// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__2-_Rv","overflowing":"ReadFullNote_overflowing__1JM8E"};